import PropTypes from 'prop-types';
import React from 'react';
import ReactTable from 'react-table';

import 'react-table/react-table.css';
import '../config-by-key/Overlay.css';

import { ButtonBlack } from '../../reusable';

const formatScheduledTime = (isoString) => {
  if (!isoString) return '--';
  const [datePart, timePart] = isoString.split('T');
  if (!datePart) return '--';
  const [year, month, day] = datePart.split('-');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthName = monthNames[parseInt(month, 10) - 1] || month;
  const time = timePart ? timePart.slice(0, 5) : '';
  return `${monthName} ${parseInt(day, 10)}, ${year}, ${time} PT`;
};

const getScopeDetail = (schedule) => {
  const { hierarchy, scope, scopeType } = schedule;
  if (scopeType === 'STORE') return scope;
  if (scopeType === 'COUNTRY') return hierarchy?.country || scope;
  if (scopeType === 'GEO' || scopeType === 'GLOBAL') return hierarchy?.geo || scope;
  return scope;
};

const overlayColumns = [
  {
    accessor: 'key',
    Header: 'KEY NAME',
    id: 'keyName',
  },
  {
    accessor: (d) => `${d.scopeType} - ${getScopeDetail(d)}`,
    Header: 'SCOPE',
    id: 'scope',
  },
  {
    accessor: (d) => String(d.value),
    Header: 'NEW VALUE',
    id: 'newValue',
  },
  {
    accessor: (d) => formatScheduledTime(d.scheduledStartTime),
    Header: 'SCHEDULED FOR',
    id: 'scheduledFor',
  },
  {
    accessor: (d) => d.createdBy || d.lastModifiedBy || '--',
    Header: 'SUBMITTED BY',
    id: 'submittedBy',
  },
  {
    accessor: 'status',
    Header: 'STATUS',
    id: 'status',
  },
];

const Overlay = ({ isVisible, onClose, schedules }) => {
  if (!isVisible) return null;

  const groupKey = schedules.length > 0 ? schedules[0].key : '';

  return (
    <div className="overlay">
      <div className="overlay-content">
        <h1 className="headline-4 pb4-sm">
          Scheduled Changes for: <span className="text-color-accent">{groupKey}</span>
        </h1>
        <ReactTable
          className="-striped -highlight"
          columns={overlayColumns.map((col) => ({
            ...col,
            headerStyle: {
              background: '#333',
              color: 'white',
              fontWeight: 600,
              padding: '10px 8px',
              textAlign: 'left',
            },
            style: { padding: '12px 8px', textAlign: 'left' },
          }))}
          data={schedules}
          defaultPageSize={schedules.length}
          getTdProps={() => ({
            style: { display: 'flex', flexDirection: 'column', justifyContent: 'center' },
          })}
          showPagination={false}
        />
        <div className="pt4-sm">
          <ButtonBlack label="Close" onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

Overlay.defaultProps = {
  schedules: [],
};

Overlay.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  schedules: PropTypes.arrayOf(PropTypes.shape({
    createdBy: PropTypes.string,
    key: PropTypes.string,
    lastModifiedBy: PropTypes.string,
    scheduledStartTime: PropTypes.string,
    scope: PropTypes.string,
    scopeType: PropTypes.string,
    status: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  })),
};

export default Overlay;
